import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { getLogger } from 'loglevel';

import { SubmitStep } from '@apple/features/cart-retail/components/steps/submit';

const log = getLogger('cart');

export const Route = createFileRoute('/_authed/cart/_steps/submit')({
	component: RouteComponent,
	wrapInSuspense: true,
});

function RouteComponent() {
	const navigate = useNavigate();
	return (
		<SubmitStep
			onCartSubmitted={result => {
				log.debug('Cart submitted', result);
				void navigate({
					to: '/cart/confirmation/$salesOrderNumber',
					params: { salesOrderNumber: result.salesOrderNumber },
					search: { cartId: result.completedBulkOrderId },
				});
			}}
		/>
	);
}
